const initialState = [];

const ADD_ACTIVITY_GROUP = 'selectedActivityGroups/ADD_ACTIVITY_GROUP';
const REMOVE_ACTIVITY_GROUP = 'selectedActivityGroups/REMOVE_ACTIVITY_GROUP';
const CLEAR_ACTIVITY_GROUP = 'selectedActivityGroups/CLEAR_ACTIVITY_GROUP';

export const addActivityGroupToSelection = activityGroup => ({
  type: ADD_ACTIVITY_GROUP,
  activityGroup
});

export const removeActivityGroupFromSelection = activityGroup => ({
  type: REMOVE_ACTIVITY_GROUP,
  activityGroup
});

export const clearActivityGroupSelection = () => ({
  type: CLEAR_ACTIVITY_GROUP
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ACTIVITY_GROUP:
      return [...state, action.activityGroup];
    case REMOVE_ACTIVITY_GROUP:
      return state.filter(act => act !== action.activityGroup);
    case CLEAR_ACTIVITY_GROUP:
      return initialState;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/selectedActivityGroups.js